import React from 'react';
import moment from 'moment';
import { useTranslation } from 'react-i18next';

import { delimitNumber } from '@src/utils/number';
import { StyledPackageV2 } from './index.style';
import RemainingCredits from './RemainingCredits';
import ExpDate from '../components/ExpDate';
import WarningAdvancedVoice from './WarningAdvancedVoice';

const PackageV2 = ({
  isLocked,
  credits,
  packageExpiryDate,
  isMobile,
  hasPreservationExpired,
  isFreePackage,
  isApiPackage,
  isCustomPackage,
}) => {
  const { i18n } = useTranslation();
  const { t, language } = i18n;

  const isExpiredPackage =
    packageExpiryDate && moment().isAfter(moment(packageExpiryDate));

  const showNoteWarningAdvancedVoice =
    !isApiPackage &&
    !isFreePackage &&
    !isCustomPackage &&
    !isExpiredPackage &&
    credits > 0;

  return (
    <StyledPackageV2>
      {(!hasPreservationExpired || isFreePackage) && (
        <>
          <RemainingCredits
            credits={`${delimitNumber(credits, language)} ${
              isMobile ? '' : t('charactersLower')
            }`}
            isLocked={isLocked}
          />
        </>
      )}
      <ExpDate packageExpiryDate={packageExpiryDate} />
      {showNoteWarningAdvancedVoice && <WarningAdvancedVoice />}
    </StyledPackageV2>
  );
};

export default PackageV2;
